import { BaseItem } from './common';

export type JsonVersion = 'v0' | 'v1';
export const ValidVersions: { [key in JsonVersion]: JsonVersion } = {
  v0: 'v0', // before extract service
  v1: 'v1', // matched to v1 of backend/extract service
};
export const ValidVersionsValues = Object.values(ValidVersions);

export enum Provider {
  Google = 'google',
  Ibm = 'ibm',
  Notable = 'notable',
}

export enum RecordingKind {
  Visit = 'visit',
  Dictation = 'dictation',
  Unknown = 'unknown',
}

export interface Word {
  confidence: number;
  start_ms: number;
  end_ms: number;
  speaker: number;
  word: string;
}

export interface Alternative {
  confidence: number;
  start_ms: number;
  end_ms: number;
  speaker: number;
  text: string;
  words: Word[];
}

export interface TranscriptPart {
  speaker: number;
  start_ms: number;
  end_ms: number;
  alternatives: Alternative[]; // start by just using the first alternative
}

export interface DictationTranscript {
  rawText: string;
  isRealTime?: boolean;
  // and other stuff
}

export interface StructuredDictation {
  dictationTranscript: DictationTranscript;
  // and other stuff
}

export interface Transcript extends BaseItem {
  recordingId: string;
  provider: Provider;
  rawText: string; // diaraized text of conversation
  conversation: TranscriptPart[];
  jsonVersion: JsonVersion;
  recordingKind: RecordingKind;
  structuredDictation: StructuredDictation | null;
}
